import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type AlertType = 'error' | 'warning' | 'success' | 'info' | 'inactive';

const ALERT_ICONS: Record<AlertType, string> = {
  error: 'error',
  warning: 'warning',
  success: 'check_circle',
  info: 'info',
  inactive: 'pause_circle',
};

@Component({
  selector: 'vectronic-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  imports: [MatIconModule],
})
export class AlertComponent {
  type = input<AlertType>('error');
  icon = computed(() => ALERT_ICONS[this.type()]);
}
